import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material.module';
import { FormsModule } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FlexLayoutModule} from '@angular/flex-layout';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { PlayerComponent } from './components/player/player.component';
import { SharedService } from './services/shared.service';
import { SettingsComponent } from './components/settings/settings.component';
import { LoginComponent } from './components/login/login.component';

const config = {
  apiKey: "AIzaSyAA_NfjEdXR_LVCumgxOlkaGwHD02zQLZQ",
  authDomain: "calcutta-auction.firebaseapp.com",
  databaseURL: "https://calcutta-auction.firebaseio.com",
  projectId: "calcutta-auction",
  storageBucket: "calcutta-auction.appspot.com",
  messagingSenderId: "140623325035"
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PlayerComponent,
    SettingsComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(config),  // Add this
    AngularFirestoreModule,
    FormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule
  ],
  providers: [AngularFireAuth,
    SharedService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts